(function () {
  if (window.__fdPdpVisualSystem20260715) return;
  window.__fdPdpVisualSystem20260715 = true;

  var normalize = function (value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  };

  var getWrapperTitle = function (wrapper) {
    var title = wrapper.querySelector('.bcpo-title, .bcpo-label, .bcpo-label label');
    if (title) return title.textContent;
    var children = Array.prototype.slice.call(wrapper.children || []);
    var firstDirectLabel = children.find(function (child) { return child.tagName === 'LABEL'; });
    return firstDirectLabel ? firstDirectLabel.textContent : (wrapper.getAttribute('data-title') || '');
  };

  var isFullWidthOption = function (title, wrapper) {
    if (wrapper.classList.contains('fd-bcpo-color-option')) return true;
    return /(^| )(color|colour|fabric)( |$)|install(ation)? type|warranty|room label|measurement guide|customize/.test(title);
  };

  var decorateNeutralBcpo = function (root) {
    if (!root.classList.contains('fd-pdp--neutral-v2') || root.dataset.windowTreatment !== 'true') return;
    var bcpo = root.querySelector('#bcpo');
    if (!bcpo) return;

    var wrappers = Array.prototype.slice.call(bcpo.querySelectorAll('.selector-wrapper'))
      .filter(function (wrapper) { return !wrapper.parentElement.closest('.selector-wrapper'); });
    if (!wrappers.length) return;

    var layoutParents = new Set();
    wrappers.forEach(function (wrapper) {
      var title = normalize(getWrapperTitle(wrapper));
      wrapper.classList.add('fd-bcpo-layout-item');
      wrapper.classList.toggle('fd-bcpo-layout-span-2', isFullWidthOption(title, wrapper));
      wrapper.dataset.fdVisualOption = title.replace(/\s+/g, '-');
      if (wrapper.parentElement) layoutParents.add(wrapper.parentElement);
    });

    layoutParents.forEach(function (parent) { parent.classList.add('fd-bcpo-layout-grid'); });
    if (wrappers.every(function (wrapper) { return wrapper.parentElement === bcpo; })) {
      bcpo.classList.add('fd-bcpo-layout-grid');
    }
  };

  var decorateBambooGuideLinks = function (root) {
    if (!root.classList.contains('fd-pdp--neutral-v2')) return;
    var guideLabels = {
      'bamboo-depth': 'Window depth & headrail guide',
      'bamboo-measurement': 'Measurement finder & guide',
      'bamboo-lining': 'Liner & shading guide'
    };

    Object.keys(guideLabels).forEach(function (key) {
      var link = root.querySelector('.fd-pdp-inline-guide-link[data-fd-inline-guide="' + key + '"]');
      if (!link) return;
      if (link.textContent.trim() !== guideLabels[key]) link.textContent = guideLabels[key];
      link.classList.add('fd-pdp-visual-guide-link');
    });
  };

  var neutralMobileQuery = window.matchMedia('(max-width: 768px)');

  var alignNeutralWindowTreatmentPurchaseSequence = function (root) {
    if (!root || !root.matches('.fd-pdp--neutral-v2[data-window-treatment="true"]')) return;
    var form = root.querySelector('.fd-pdp-form');
    if (!form) return;

    var children = Array.prototype.slice.call(form.children || []);
    var qty = children.find(function (node) { return node.classList.contains('fd-pdp-qty-row'); });
    var zip = children.find(function (node) { return node.classList.contains('fd-pdp-zip'); });
    var atc = children.find(function (node) { return node.classList.contains('fd-pdp-atc'); });
    var quantityInput = root.querySelector('.fd-pdp-qty-control input[data-fd-quantity]');

    if (quantityInput && !quantityInput.hasAttribute('aria-label') && !quantityInput.hasAttribute('aria-labelledby')) {
      quantityInput.setAttribute('aria-label', 'Quantity');
    }

    if (neutralMobileQuery.matches) {
      if (qty && zip && qty.nextElementSibling !== zip) qty.insertAdjacentElement('afterend', zip);
      if (zip && atc && zip.nextElementSibling !== atc) zip.insertAdjacentElement('afterend', atc);
    } else if (qty && atc && qty.nextElementSibling !== atc) {
      qty.insertAdjacentElement('afterend', atc);
    }
  };

  var getProductCardKind = function (card) {
    var link = card.querySelector('.grid-product__link[href*="/products/"]');
    var handle = normalize(card.getAttribute('data-product-handle'));
    if (!handle && link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/i);
      handle = normalize(match ? match[1] : '');
    }

    var title = normalize(card.querySelector('.grid-product__title') && card.querySelector('.grid-product__title').textContent);
    var signature = (handle + ' ' + title).trim();
    if (/sample book|sample booklet|sample pamphlet|fabric sample|swatch book|jenna linen book/.test(signature)) return 'sample-book';
    if (/gift card|gift certificate/.test(signature)) return 'gift-card';
    if (/curtain|drapery|drape|roman shade|bamboo shade|woven shade|window shade|window blind|window treatment|valance/.test(signature)) return 'window-treatment';
    return 'standard';
  };

  var decorateProductCards = function (section) {
    section.querySelectorAll('.grid-product:not([data-fd-card-kind])').forEach(function (card) {
      card.dataset.fdCardKind = getProductCardKind(card);
    });
  };

  var nodeMatchesOrContains = function (node, selector) {
    var element = node && node.nodeType === 1 ? node : node && node.parentElement;
    if (!element) return false;
    return Boolean(
      (element.matches && element.matches(selector))
      || (element.closest && element.closest(selector))
      || (element.querySelector && element.querySelector(selector))
    );
  };

  var mutationNodesMatch = function (record, selector) {
    if (!record || record.type !== 'childList') return false;
    var changedNodes = Array.prototype.slice.call(record.addedNodes || [])
      .concat(Array.prototype.slice.call(record.removedNodes || []));
    return changedNodes.some(function (node) { return nodeMatchesOrContains(node, selector); });
  };

  var observeProductCards = function (section) {
    var frame = 0;
    var decorate = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        decorateProductCards(section);
      });
    };

    decorate();
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (records) {
        var cardsChanged = records.some(function (record) {
          return mutationNodesMatch(record, '.grid-product, .grid-product__link[href*="/products/"], .grid-product__title');
        });
        if (cardsChanged) decorate();
      });
      observer.observe(section, { childList: true, subtree: true });
    } else {
      var retryDelays = [250, 700, 1500, 3000];
      var retryIndex = 0;
      var retry = function () {
        decorate();
        if (section.querySelector('.grid-product') || retryIndex >= retryDelays.length) return;
        var delay = retryDelays[retryIndex];
        retryIndex += 1;
        window.setTimeout(retry, delay);
      };
      retry();
    }
  };

  var observeRoot = function (root) {
    if (!root.classList.contains('fd-pdp--neutral-v2')) return;
    var frame = 0;
    var decorate = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        decorateNeutralBcpo(root);
        decorateBambooGuideLinks(root);
        alignNeutralWindowTreatmentPurchaseSequence(root);
      });
    };

    var observedBcpo = null;
    var bcpoObserver = null;
    var bindBcpoObserver = function () {
      var nextBcpo = root.querySelector('#bcpo');
      if (nextBcpo === observedBcpo) return Boolean(nextBcpo);
      if (bcpoObserver) bcpoObserver.disconnect();
      observedBcpo = nextBcpo || null;
      if (!observedBcpo || !window.MutationObserver) return Boolean(observedBcpo);

      bcpoObserver = new MutationObserver(function (records) {
        var relevant = records.some(function (record) {
          if (mutationNodesMatch(record, '.selector-wrapper, .fd-pdp-inline-guide-link')) return true;
          var target = record.target && record.target.nodeType === 1
            ? record.target
            : record.target && record.target.parentElement;
          return record.type === 'characterData'
            && target
            && target.closest
            && Boolean(target.closest('.bcpo-title, .bcpo-label, .selector-wrapper > label'));
        });
        if (relevant) decorate();
      });
      bcpoObserver.observe(observedBcpo, { childList: true, subtree: true, characterData: true });
      decorate();
      return true;
    };

    var form = root.querySelector('.fd-pdp-form');
    if (form && window.MutationObserver) {
      var formObserver = new MutationObserver(function (records) {
        var bcpoChanged = records.some(function (record) { return mutationNodesMatch(record, '#bcpo'); });
        var sequenceChanged = records.some(function (record) {
          return mutationNodesMatch(record, '.fd-pdp-qty-row, .fd-pdp-zip, .fd-pdp-atc');
        });
        if (bcpoChanged) bindBcpoObserver();
        if (bcpoChanged || sequenceChanged) decorate();
      });
      formObserver.observe(form, { childList: true });
    }

    var guideHost = root.querySelector('.fd-pdp-custom');
    if (guideHost && window.MutationObserver) {
      var guideObserver = new MutationObserver(function (records) {
        if (records.some(function (record) {
          return mutationNodesMatch(record, '.fd-pdp-inline-guide-link');
        })) decorate();
      });
      guideObserver.observe(guideHost, { childList: true, subtree: true });
    }

    decorate();
    if (bindBcpoObserver()) return;

    var retryDelays = [250, 700, 1500, 3000];
    var retryIndex = 0;
    var retryMissingBcpo = function () {
      if (bindBcpoObserver() || retryIndex >= retryDelays.length) return;
      var delay = retryDelays[retryIndex];
      retryIndex += 1;
      window.setTimeout(retryMissingBcpo, delay);
    };
    retryMissingBcpo();
  };

  var neutralWindowTreatmentSelector = 'body.template-product .fd-pdp.fd-pdp--neutral-v2[data-window-treatment="true"]';
  var realignNeutralWindowTreatmentRoots = function () {
    document.querySelectorAll(neutralWindowTreatmentSelector).forEach(alignNeutralWindowTreatmentPurchaseSequence);
  };

  document.querySelectorAll('body.template-product .fd-pdp.fd-pdp--neutral-v2[data-fd-product]').forEach(observeRoot);
  if (neutralMobileQuery.addEventListener) {
    neutralMobileQuery.addEventListener('change', realignNeutralWindowTreatmentRoots);
  } else if (neutralMobileQuery.addListener) {
    neutralMobileQuery.addListener(realignNeutralWindowTreatmentRoots);
  }
  document.querySelectorAll('body.template-product product-recommendations[data-source-product-handle], body.template-product [data-section-type="recently-viewed"][data-product-handle]').forEach(observeProductCards);
})();
